export default "__VITE_ASSET__DJNbHMBg__"